import React, { Component } from "react";

import ReactTooltip from "react-tooltip";

window.tooltipAlreadyShown = [];

export class TooltipWithAutoHide extends Component {
  initiallyShown = false;
  componentDidMount() {
    if (
      this.props.showInitial &&
      !window.tooltipAlreadyShown.includes(this.props.id)
    ) {
      this.showTooltip();
      window.tooltipAlreadyShown.push(this.props.id);
    }
    if (this.props.hideAfter) {
      setTimeout(() => {
        this.hideTooltip();
      }, this.props.hideAfter);
    }
  }

  showTooltip() {
    let tooltip = document.querySelectorAll(
      `[data-tip][data-for="${this.props.id}"]`
    )[0];
    ReactTooltip.show(tooltip);
  }

  hideTooltip() {
    let tooltip = document.querySelectorAll(
      `[data-tip][data-for="${this.props.id}"]`
    )[0];
    ReactTooltip.hide(tooltip);
  }

  render() {
    const { children, showInitial, ...props } = this.props;
    if (!children) return null;

    return <ReactTooltip {...props}>{children}</ReactTooltip>;
  }
}
